import React from "react";
import "./App.css";
import ProblemList from "./components/ProblemList";

function App() {
  return (
    <div className="App">
      <ProblemList />
    </div>
  );
}

export default App;
